import { connect } from 'react-redux'

import SearchPage from './searchPage'
import fetchSearchResults from '../../../common/actions/searchPage'

const mapStateToProps = (state) => {
  const {
    results,
    resultsUrl,
    loading,
    seoMeta,
    ingestedContent,
    relatedSearches,
    timeout,
    studioRecommendations
  } = state.searchPage
  const {
    currentSite,
    baseUrl
  } = state.common
  const {
    user
  } = state
  return {
    results,
    resultsUrl,
    loading,
    seoMeta,
    studioRecommendations,
    ingestedContent,
    currentSite,
    relatedSearches,
    user,
    baseUrl,
    timeout
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

const SearchPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchPage)

SearchPageContainer.loadData = (store, parsedUrl, opts) => {
  return store.dispatch(fetchSearchResults(parsedUrl, opts))
}

export default SearchPageContainer



// WEBPACK FOOTER //
// ./client/pages/search/searchPageContainer.js